export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      toggleTipHelpText: {
        title: 'Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text Toggle tip with ui:help text',
        type: 'string'
      },
      toggleTipHelpObject: {
        title: 'Toggle tip with ui:help object',
        type: 'string'
      },
      modalLongHelpText: {
        title: 'Long help text - opens in modal',
        type: 'string'
      },
      modalHtmlHelpText: {
        title: 'Help text with html - opens in modal',
        type: 'string'
      },
      helpLink: {
        title: 'Help with link',
        type: 'string'
      },
      helpDecoratedField: {
        title: 'Decorated field with help',
        type: 'integer'
      },
      arrayWithHelpText: {
        type: 'array',
        title: 'DSA with Help',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string',
              title: 'id'
            },
            helpInsideDsa: {
              type: 'string',
              title: 'Help on field inside DSA',
              maxLength: 20000
            },
            helpDecoratedFieldInsideDsa: {
              type: 'integer',
              title: 'Help on decorated field inside DSA',
              maxLength: 20000
            }
          },
          required: [],
          dependencies: {},
          additionalProperties: false
        },
        minItems: 1
      },
      sample_question: {
        type: 'string',
        title: 'Sample Question',
        maxLength: 20000
      },
      static_labelled: {
        type: 'object',
        properties: {
          sample_question: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        title: 'Labelled Static Component'
      }
    }
  },
  uiSchema: {
    toggleTipHelpText: {
      'ui:widget': 'text',
      'ui:help': 'Traditional help used by react-jsonschema-form'
    },
    toggleTipHelpObject: {
      'ui:widget': 'text',
      'ui:help': {
        text: 'Help text shoved into an object',
        escape: true
      }
    },
    modalLongHelpText: {
      'ui:widget': 'text',
      'ui:help': {
        text: 'Authors who are selected from the drop-down list are known CBA users. Thus, data is typically entered into the Name and Institution fields only for non-SDSU authors.  However, by entering data in the Name field, you can override the name attached to the user by Activity Insight for this record.  Faculty with name changes can use this feature to ensure the correct author/editor name is used in Activity Insight reports.',
        escape: true
      }
    },
    modalHtmlHelpText: {
      'ui:widget': 'text',
      'ui:help': {
        text: '<a href="http://grants.nih.gov/grants/funding/phs398/phs398.pdf" target="_blank">Click Here for Instructions</a>',
        escape: false
      }
    },
    helpLink: {
      'ui:widget': 'text',
      'ui:help': {
        href: 'http://www.google.com'
      }
    },
    helpDecoratedField: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      },
      'ui:help': {
        text: 'Help text on decorated question',
        escape: true
      }
    },
    text_helpText1: {
      'ui:title': 'Static text with associated help in tooltip (default escape)',
      'ui:help': 'Help text displayed in a tooltip 1'
    },
    text_helpText2: {
      'ui:title': 'Static text with associated help in tooltip (explicit escape)',
      'ui:help': {
        text: 'Help text displayed in a tooltip 2',
        escape: true
      }
    },
    text_helpText3: {
      'ui:title': 'Static text with associated help in modal (unescape)',
      'ui:help': {
        text: 'Help text displayed in a modal',
        escape: false
      }
    },
    text_helpLink: {
      'ui:title': 'Static text with external help link',
      'ui:help': {
        href: 'http://www.google.com',
        escape: false
      }
    },
    '2114811': {
      'ui:title': {
        text: 'Question Group with Help Question Group with Help Question Group with Help Question Group with Help Question Group with Help Question Group with Help Question Group with Help Question Group with Help',
        escape: false
      },
      'ui:help': {
        text: 'Sample Help Text',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: false,
        compact: false
      }
    },
    sample_question: {
      'ui:title': {
        text: 'Sample Question',
        escape: false
      },
      'ui:help': {
        text: 'Help text on question inside question group',
        escape: true
      },
      'ui:widget': 'text'
    },
    static_labelled: {
      'ui:title': {
        text: 'Static Sub-Component with Help Static Sub-Component with Help Static Sub-Component with Help Static Sub-Component with Help Static Sub-Component with Help Static Sub-Component with Help',
        escape: false
      },
      'ui:help': {
        text: 'Help text to show next to static sub-component title.',
        escape: true
      },
      'dm:layout': [{
        id: 'sample_question',
        type: 'field'
      }],
      sample_question: {
        'ui:title': {
          text: 'Sample Question',
          escape: false
        },
        'ui:help': {
          text: 'Help text on question inside static sub-component',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    arrayWithHelpText: {
      items: {
        'dm:layout': [{
          id: 'helpInsideDsa',
          type: 'field'
        }, {
          id: 'helpDecoratedFieldInsideDsa',
          type: 'field'
        }],
        helpInsideDsa: {
          'ui:title': {
            text: 'Help on field inside DSA',
            escape: false
          },
          'ui:widget': 'text',
          'ui:help': {
            text: 'Help text on question inside DSA',
            escape: true
          }
        },
        helpDecoratedFieldInsideDsa: {
          'ui:widget': 'text',
          'ui:options': {
            after: '%'
          },
          'ui:help': {
            text: 'Help text on decorated question inside DSA',
            escape: true
          }
        }
      },
      'ui:title': {
        text: 'DSA with Help',
        escape: false
      },
      'ui:help': {
        text: 'Help text to show next to DSA title.',
        escape: true
      },
      'ui:options': {
        itemName: 'Item'
      }
    },
    'dm:layout': [{
      type: 'field',
      id: 'toggleTipHelpText'
    }, {
      type: 'field',
      id: 'toggleTipHelpObject'
    }, {
      type: 'field',
      id: 'modalLongHelpText'
    }, {
      type: 'field',
      id: 'modalHtmlHelpText'
    }, {
      type: 'field',
      id: 'helpLink'
    }, {
      type: 'field',
      id: 'helpDecoratedField'
    }, {
      type: 'text',
      id: 'text_helpText1'
    }, {
      type: 'text',
      id: 'text_helpText2'
    }, {
      type: 'text',
      id: 'text_helpText3'
    }, {
      type: 'text',
      id: 'text_helpLink'
    }, {
      id: '2114811',
      type: 'group',
      children: [{
        id: 'sample_question',
        type: 'field'
      }]
    }, {
      id: 'static_labelled',
      type: 'field'
    }, {
      type: 'array',
      id: 'arrayWithHelpText'
    }]
  },
  formData: {}
};